import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {Body1} from '@adv-mt/ui/typography'

import AppraisalCrossSell from './AppraisalCrossSell.js'
import {BASE_CLASS} from './FormFields.js'
import PublishAdCrossSell from './PublishAdCrossSell.js'
import SuccessAppDownload from './SuccessAppDownload.js'

const SUCCESS_LITERALS = {
  DEALER: appName => `CONTACT_SELLER_V2.SUCCESS.DEALER_${appName}`,
  PRIVATE: 'CONTACT_SELLER_V2.SUCCESS.PRIVATE',
  PRIVATE_WITH_PHONE: 'CONTACT_SELLER_V2.SUCCESS.PRIVATE_WITH_PHONE'
}

const resolveSuccessLiteral = ({contractId, hasPhone, appName}) => {
  if (contractId) {
    return SUCCESS_LITERALS.DEALER(appName)
  }

  return hasPhone ? SUCCESS_LITERALS.PRIVATE_WITH_PHONE : SUCCESS_LITERALS.PRIVATE
}

const SuccessState = ({contractId, hasPhone = false, isRenting = false}) => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const {IS_INSTANT_OFFER_FEATURE_ENABLED} = config.get('seller')
  const appName = config.get('APP_NAME')

  return (
    <div className={`${BASE_CLASS}-success`}>
      <Body1 className={`${BASE_CLASS}-successBody`}>
        {i18n.t(resolveSuccessLiteral({contractId, hasPhone, appName}))}
      </Body1>
      <SuccessAppDownload />
      {!isRenting && (IS_INSTANT_OFFER_FEATURE_ENABLED ? <AppraisalCrossSell /> : <PublishAdCrossSell />)}
    </div>
  )
}

SuccessState.displayName = 'ContactFormV2SuccessState'

SuccessState.propTypes = {
  contractId: PropTypes.string,
  hasPhone: PropTypes.bool,
  isRenting: PropTypes.bool
}

export {SUCCESS_LITERALS, resolveSuccessLiteral}

export default SuccessState
